module.exports = __webpack_public_path__ + "img/best-price-icon.834567f3.svg";